export default __webpack_public_path__ + "static/media/fdaycleb.e0d52ce1a2cf5255ea756361def03ecd.svg";